import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import withModal from '../../../../lib/hoc/withModal';
import { asyncSimpleModal } from '../../../../lib/common';
import RejectStoreModal from '../../../../views/brand/common/modal/RejectStoreModal';
import { brandActions } from '../../../../store/modules/brand';

class RejectStoreModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.setData({
      path: ['rejectBrandModal'],
      value: {
        isOpen: false,
        data: {},
      },
    });
  };

  /**
   * 거절하기
   */
  onSubmit = async () => {
    const { data, rejectBrand } = this.props;
    const { storeId, rejectTypeList, rejectReason } = data;

    /**
     *  거절 타입과 사유를 모두 입력해야만 거절 가능
     */
    if (rejectTypeList.length > 0 && rejectReason) {
      const confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '판매점 입점 승인 거절',
        message: '해당 판매점의 입점을 거절합니다. 계속 진행하시겠습니까? ',
      });

      if (confirmResult) {
        rejectBrand({
          storeId,
          rejectTypeList,
          rejectReason,
        });
      }

      this.closeModal();
    } else {
      await asyncSimpleModal({
        type: 'error',
        title: '판매점 입점 승인 거절',
        message: '거절 타입과 사유를 입력해주세요!',
      });
    }
  };

  render() {
    return <RejectStoreModal {...this.state} {...this.props} closeModal={this.closeModal} onSubmit={this.onSubmit} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.brand.rejectBrandModal.isOpen,
    data: state.brand.rejectBrandModal.data,
  };
};

const mapDispatchToProps = {
  setData: brandActions.setData,
  rejectBrand: brandActions.rejectBrand,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(RejectStoreModalContainer)));
